module.exports = __webpack_public_path__ + "static/media/salva_rate.78bfa2cd.png";